// @flow
import * as React from 'react';
import { withLeaflet } from 'react-leaflet';
import L from 'leaflet';
import type { LeafletContext, ControlPosition } from 'react-leaflet/lib/types';

// Control options from https://github.com/codeofsumit/leaflet.pm/blob/develop/src/js/Toolbar/L.PM.Toolbar.js

// const {
//     _makeButton: PMButtonMakeButtonSuper,
// } = L.Control.PMButton.prototype;
//
//
// L.Control.PMButton.include({
//     _makeButton(button) {
//         const btn = PMButtonMakeButtonSuper.call(this, button);
//         if (button.title) {
//             btn.children[0].appendChild(document.createTextNode(button.title));
//         }
//         return btn;
//     },
// });

type Props = {
    leaflet: LeafletContext,
    type: 'Marker' | 'Polygon' | 'Polyline' | 'CircleMarker',
    title: string,
    onClick: (e: Object) => any,
    onCreated: (e: Object) => any,
    position: ControlPosition,
    setDrawing: Function,
    allowSelfIntersection?: boolean,
}


@withLeaflet
class DrawControl extends React.PureComponent<Props> {
    control: Object;

    activeTimeOut: TimeoutID | null = null;

    active = false;

    static defaultProps = {
        leaflet: {},
        onClick: () => {},
        onCreated: undefined,
        position: 'topright',
        allowSelfIntersection: false,
    };

    componentDidMount() {
        const { leaflet: { map } } = this.props;

        this.control = this._createControl();
        this.control.addTo(map);

        if (map) {
            map.on('pm:drawend', this._handleDrawEnd);
            map.on('pm:create', this._handleCreated);
        }
    }

    componentWillUnmount() {
        const { leaflet: { map } } = this.props;

        if (this.control) {
            this.control.remove();
        }

        if (map) {
            map.off('pm:drawend', this._handleDrawEnd);
            map.off('pm:create', this._handleCreated);
        }
    }

    _createControl = () => {
        const { type, position } = this.props;
        // $FlowFixMe
        const options = this[`_get${type}Options`]();
        options.onClick = this._handleClick;
        options.position = position;

        return new L.Control.PMButton(options);
    };

    _getMarkerOptions = () => {
        const { title, leaflet: { map }, allowSelfIntersection } = this.props;
        return {
            title,
            className: 'control-icon leaflet-pm-icon-marker',
            jsClass: 'Marker',
            afterClick: () => {
                // toggle drawing mode
                if (map) {
                    map.pm.Draw.Marker.toggle({
                        allowSelfIntersection,
                    });
                }
            },
            doToggle: true,
            toggleStatus: false,
            disableOtherButtons: true,
            actions: ['cancel'],
        };
    };

    _getPolygonOptions = () => {
        const { title, leaflet: { map }, allowSelfIntersection } = this.props;
        return {
            title,
            className: 'control-icon leaflet-pm-icon-polygon',
            jsClass: 'Polygon',
            afterClick: () => {
                // toggle drawing mode
                if (map) {
                    map.pm.Draw.Polygon.toggle({
                        allowSelfIntersection,
                    });
                }
            },
            doToggle: true,
            toggleStatus: false,
            disableOtherButtons: true,
            actions: ['finish', 'removeLastVertex', 'cancel'],
        };
    };

    _getPolylineOptions = () => {
        const { title, leaflet: { map }, allowSelfIntersection } = this.props;
        return {
            title,
            className: 'control-icon leaflet-pm-icon-polygon',
            jsClass: 'Line',
            afterClick: () => {
                // toggle drawing mode
                if (map) {
                    map.pm.Draw.Line.toggle({
                        allowSelfIntersection,
                    });
                }
            },
            doToggle: true,
            toggleStatus: false,
            disableOtherButtons: true,
            actions: ['finish', 'removeLastVertex', 'cancel'],
        };
    };

    _getCircleMarkerOptions = () => {
        const { title } = this.props;
        // TODO: FIX IT
        return {
            title,
            jsClass: 'CircleMarker',
        };
    };

    _handleClick = (e: Object) => {
        const { onClick, setDrawing } = this.props;

        if (this.activeTimeOut) {
            clearTimeout(this.activeTimeOut);
            this.activeTimeOut = null;
        }

        this.active = true;
        setDrawing(true);

        if (onClick) {
            onClick(e);
        }
    };

    _handleDrawEnd = () => {
        const { setDrawing } = this.props;
        this.activeTimeOut = setTimeout(() => {
            this.active = false;
            setDrawing(false);
        }, 300);
        if (this.control) {
            this.control.toggle(false);
        }
    };

    _handleCreated = (e: Object) => {
        const { onCreated } = this.props;
        if (this.active && onCreated) {
            onCreated(e);
        }
    };

    render() {
        return null;
    }
}

export default DrawControl;
